import * as React from "react";
import Card from "../core/Card";
import { inviteUser } from "../../libs/user";
import { toast } from "../../utils";
import * as H from "history";
import { RailsUserContext } from "../../libs/user_context";
import EmployeeForm from "../employee/EmployeeForm";
import * as Sentry from "@sentry/browser";

interface IProps {
  org: IOrganization;
  routerHistory: H.History;
  currentUser?: IUser;
}

function InviteUser({ org, routerHistory }: IProps) {
  return (
    <Card title={`Invite New User to ${org.name}`}>
      <EmployeeForm
        org={org}
        onSubmit={(values, { setSubmitting }) => {
          setSubmitting(true);
          inviteUser(values, org.id)
            .then(data => {
              setSubmitting(false);
              if (data.msg == "Duplicate email") {
                toast.error(
                  `Email already exists, try again with different email`
                );
              } else {
                toast.success(`User has been invited!`);
                routerHistory.push("/");
              }
            })
            .catch(e => {
              setSubmitting(false);
              toast.error(`Error occurred while inviting user.`);
              Sentry.captureException(e);
              if (process.env.NODE_ENV !== "production") {
                // eslint-disable-next-line no-console
                console.error(e);
              }
            });
        }}
      />
    </Card>
  );
}

export default (props: IProps) => (
  <RailsUserContext.Consumer>
    {userContext => (
      <InviteUser
        currentUser={userContext.user}
        org={props.org}
        routerHistory={props.routerHistory}
      />
    )}
  </RailsUserContext.Consumer>
);



// WEBPACK FOOTER //
// ./app/javascript/components/org/InviteUser.tsx